import React, { useEffect, useState } from 'react'
import { Navigate, useNavigate, Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import axios from 'axios'
import { ApiUrl, Headers } from '../services/ApiUrl';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Figure from 'react-bootstrap/Figure';
import ListGroup from 'react-bootstrap/ListGroup';
import Badge from 'react-bootstrap/Badge';
import Accordion from 'react-bootstrap/Accordion';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie, Doughnut } from 'react-chartjs-2';
import SystemOptionsForm from './OpcionesSistemaActualizar';
import ResultadosVotacion from './ResultadosVotacion';
import { useUserAdminStore } from '../stores/userAdmin';
import VotosEnBlanco from './VotosEnBlanco';

ChartJS.register(ArcElement, Tooltip, Legend);



const PanelAdmin = () => {

    const [proyectosPP2023, setProyectosPP2023] = useState([])
    const [proyectosPPJoven2023, setProyectosPPJoven2023] = useState([])
    const [usuariosProyectos, setUsuariosProyectos] = useState([])
    const [loadingPP2023, setLoadingPP2023] = useState(false)
    const [loadingPPJoven2023, setLoadingPPJoven2023] = useState(false)
    const [loadingUsuarios, setLoadingUsuarios] = useState(false)
    const [resumenPP2023, setResumenPP2023] = useState([])
    const [resumenPPJoven, setResumenPPJoven] = useState([])

    const { userAdmin } = useUserAdminStore();


    const dataPP2023presentados = {
        labels: ['Presentados ' + resumenPP2023.presentados, 'Borrador ' + resumenPP2023.borrador],
        datasets: [
            {
                label: 'PP General 2023',
                data: [resumenPP2023.presentados, resumenPP2023.borrador],
                backgroundColor: [
                    'rgb(0, 161, 53)',
                    'rgb(255, 237, 0)',
                ],
            },
        ],
    };

    const dataPP2023localidad = {
        labels: ['Trenque Lauquen: ' + resumenPP2023.tlauquen, '30 de Agosto: ' + resumenPP2023.tdeagosto, 'Beruti: ' + resumenPP2023.beruti, 'Girodias: ' + resumenPP2023.girodias],
        datasets: [
            {
                label: 'Por localidad',
                data: [resumenPP2023.tlauquen, resumenPP2023.tdeagosto, resumenPP2023.beruti, resumenPP2023.girodias],
                backgroundColor: [
                    'rgb(0, 161, 53)',
                    'rgb(255, 237, 0)',
                    'rgb(255, 99, 132)',
                    'rgb(54, 162, 235)',
                ],

            },
        ],
    };

    const dataPP2023jovenlocalidad = {
        labels: ['Trenque Lauquen: ' + resumenPPJoven.tlauquen, '30 de Agosto: ' + resumenPPJoven.tdeagosto, 'Beruti: ' + resumenPPJoven.beruti, 'Girodias: ' + resumenPPJoven.girodias],
        datasets: [
            {
                label: 'Por localidad',
                data: [resumenPPJoven.tlauquen, resumenPPJoven.tdeagosto, resumenPPJoven.beruti, resumenPPJoven.girodias],
                backgroundColor: [
                    'rgb(0, 161, 53)',
                    'rgb(255, 237, 0)',
                    'rgb(255, 99, 132)',
                    'rgb(54, 162, 235)',
                ],

            },
        ],
    };
    const dataPP2023jovenpresentados = {
        labels: ['Presentados ' + resumenPPJoven.presentados, 'Borrador ' + resumenPPJoven.borrador],
        datasets: [
            {
                label: 'PP Joven 2023',
                data: [resumenPPJoven.presentados, resumenPPJoven.borrador],
                backgroundColor: [
                    'rgb(0, 161, 53)',
                    'rgb(255, 237, 0)',
                ],
            },
        ],
    };


    const cargarProyectosPP2023 = () => {
        setLoadingPP2023(true)
        let url = ApiUrl + 'relations?rel=users_proyectos,pp2023_proyectos&type=,user&select=*&linkTo=categoria_proyecto&equalTo=PP General 2023'
        axios.get(url, { headers: Headers })
            .then(response => {
                setProyectosPP2023(response.data.results.filter(proyectos => (proyectos.id_user !== "1")))
                setResumenPP2023({
                    ...resumenPP2023,
                    presentados: response.data.results.filter(proyectos => (proyectos.estado === "Presentado")).length,
                    borrador: response.data.results.filter(proyectos => (proyectos.estado === "Borrador" && proyectos.id_user !== "1")).length,
                    beruti: response.data.results.filter(proyectos => (proyectos.localidad_proyecto === "Beruti")).length,
                    tlauquen: response.data.results.filter(proyectos => (proyectos.localidad_proyecto === "Trenque Lauquen")).length,
                    tdeagosto: response.data.results.filter(proyectos => (proyectos.localidad_proyecto === "30 de Agosto")).length,
                    girodias: response.data.results.filter(proyectos => (proyectos.localidad_proyecto === "Girodias")).length,
                })



            }).catch(error => {
                setProyectosPP2023([])


            })
            .finally(function () {
                setLoadingPP2023(false)
            });

    }

    const cargarProyectosPPJoven2023 = () => {
        setLoadingPPJoven2023(true)
        let url = ApiUrl + 'relations?rel=users_proyectos,pp2023_proyectos&type=,user&select=*&linkTo=categoria_proyecto&equalTo=PP Joven 2023'
        axios.get(url, { headers: Headers })
            .then(response => {
                setProyectosPPJoven2023(response.data.results)
                setResumenPPJoven({
                    ...resumenPPJoven,
                    presentados: response.data.results.filter(proyectos => (proyectos.estado === "Presentado")).length,
                    borrador: response.data.results.filter(proyectos => (proyectos.estado === "Borrador" && proyectos.id_user !== "1")).length,
                    beruti: response.data.results.filter(proyectos => (proyectos.localidad_proyecto === "Beruti")).length,
                    tlauquen: response.data.results.filter(proyectos => (proyectos.localidad_proyecto === "Trenque Lauquen")).length,
                    tdeagosto: response.data.results.filter(proyectos => (proyectos.localidad_proyecto === "30 de Agosto")).length,
                    girodias: response.data.results.filter(proyectos => (proyectos.localidad_proyecto === "Girodias")).length,
                })


            }).catch(error => {
                setProyectosPPJoven2023([])


            })
            .finally(function () {
                setLoadingPPJoven2023(false)

            });
    }

    const cargarUsuariosProyectos = () => {
        setLoadingUsuarios(true)
        let url = ApiUrl + 'getusuariosproyectos'
        axios.get(url, { headers: Headers })
            .then(response => {
                setUsuariosProyectos(response.data.results.filter(usuarios => (usuarios.id_user !== "1" && usuarios.id_user !== "3")))


            }).catch(error => {
                setUsuariosProyectos([])


            })
            .finally(function () {
                setLoadingUsuarios(false)
            });

    }

    useEffect(() => {
        const interval = setInterval(() => {
            window.location.reload();
        }, 300000); // 60000 ms = 60 segundos

        // Limpieza del intervalo cuando el componente se desmonte
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        cargarProyectosPP2023()
        cargarProyectosPPJoven2023()
        cargarUsuariosProyectos()
    }, []);
    const navigate = useNavigate();
    const navegarTo = (destino) => {
        const destinourl = '/detalleproyectos/' + destino;
        navigate(destinourl);
    }
    //console.log(resumenPP2023)   

    return (
        <>
            {userAdmin.login === false &&
                <Navigate to="/iniciarsesionadmin" />
            }
            {userAdmin.login === true &&
                <>
                    <Container>
                        <Row>
                            <Col>
                                <h1>Panel de administración</h1>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: '30px', marginBottom: '30px' }}>
                            <Col>
                                <SystemOptionsForm />
                            </Col>
                        </Row>

                        <ResultadosVotacion />

                        {1 === 0 &&
                            <>
                                <Row>
                                    <Col>

                                        <Card>

                                            <Card.Body>
                                                <Card.Title><h5>Resumen del PP general ({proyectosPP2023.length}) </h5></Card.Title>
                                                <ListGroup style={{ fontSize: '20px' }}>
                                                    <ListGroup.Item >
                                                        <div><Doughnut data={dataPP2023presentados} /></div>
                                                    </ListGroup.Item>
                                                </ListGroup>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col>

                                        <Card>

                                            <Card.Body>
                                                <Card.Title><h5>Por localidad </h5></Card.Title>
                                                <ListGroup style={{ fontSize: '20px' }}>
                                                    <ListGroup.Item >
                                                        <div><Doughnut data={dataPP2023localidad} /></div>
                                                    </ListGroup.Item>
                                                </ListGroup>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>

                                        <Card>

                                            <Card.Body>
                                                <Card.Title><h5>Resumen del PP Joven ({proyectosPPJoven2023.length}) </h5></Card.Title>
                                                <ListGroup style={{ fontSize: '20px' }}>
                                                    <ListGroup.Item >
                                                        <div><Doughnut data={dataPP2023jovenpresentados} /></div>
                                                    </ListGroup.Item>
                                                </ListGroup>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col>

                                        <Card>

                                            <Card.Body>
                                                <Card.Title><h5>Por localidad </h5></Card.Title>
                                                <ListGroup style={{ fontSize: '20px' }}>
                                                    <ListGroup.Item >
                                                        <div><Doughnut data={dataPP2023jovenlocalidad} /></div>
                                                    </ListGroup.Item>
                                                </ListGroup>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '30px' }}>
                                    <Col>
                                        <h3>Listado de proyectos PP2023 ({proyectosPP2023.length}) </h3>
                                        {loadingPP2023 &&
                                            <Spinner animation="border" role="status">
                                                <span className="visually-hidden">Cargando...</span>
                                            </Spinner>
                                        }
                                    </Col>
                                </Row>
                                <Row >

                                    {proyectosPP2023?.map(proyectoPP => {
                                        return (


                                            <Col sm={6} key={proyectoPP.id_proyecto} style={{ marginTop: '30px' }}>
                                                <Card>
                                                    {(proyectoPP.imagen_destacada !== "" && proyectoPP.imagen_destacada !== null) ?
                                                        <Card.Img variant="top" src={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${proyectoPP.imagen_destacada}`}
                                                            style={{ width: '100%', maxHeight: '15rem', objectFit: 'cover' }} />
                                                        :
                                                        <Card.Img variant="top" src="https://trenquelauquen.gov.ar/public/pp2023/uploads/default-image.jpg"
                                                            style={{ width: '100%', maxHeight: '15rem', objectFit: 'cover' }} />

                                                    }
                                                    <Card.Body>
                                                        <Card.Title style={{ minHeight: '50px' }}> {proyectoPP.titulo_proyecto} <span> </span>
                                                            {proyectoPP.estado === "Borrador" && <Badge bg="warning" text="dark">Borrador</Badge>}
                                                            {proyectoPP.estado === "Presentado" && <Badge bg="success">Presentado</Badge>}
                                                        </Card.Title>

                                                        {proyectoPP.estado === "Borrador" &&
                                                            <Alert variant="warning">
                                                                Fecha de última actualización: {proyectoPP.fecha_borrador}
                                                            </Alert>
                                                        }
                                                        {proyectoPP.estado === "Presentado" &&
                                                            <Alert variant="success">
                                                                Fecha de presentación: {proyectoPP.fecha_entrega}
                                                            </Alert>
                                                        }
                                                        <ListGroup style={{ fontSize: '20px' }}>
                                                            <ListGroup.Item ><i className="bi bi-geo-alt"></i> {proyectoPP.localidad_proyecto}</ListGroup.Item>
                                                            <ListGroup.Item><i className="bi bi-currency-dollar"></i> {proyectoPP.monto_total_estimado}</ListGroup.Item>
                                                        </ListGroup>


                                                        <Accordion>
                                                            <Accordion.Item eventKey={proyectoPP.id_proyecto}>
                                                                <Accordion.Header><span style={{ fontSize: '20px' }}><i className="bi bi-person-fill-add"> </i> {proyectoPP.name_user}</span> </Accordion.Header>
                                                                <Accordion.Body>
                                                                    <p style={{ fontSize: '18px' }}><i className="bi bi-person-vcard"></i> {proyectoPP.dni}</p>
                                                                    <p style={{ fontSize: '18px' }}><i className="bi bi-envelope-at"></i> {proyectoPP.email_user}</p>
                                                                    <p style={{ fontSize: '18px' }}><i className="bi bi-phone"></i> {proyectoPP.telefono}</p>

                                                                </Accordion.Body>
                                                            </Accordion.Item>

                                                        </Accordion>


                                                        <ListGroup>
                                                            <ListGroup.Item>Tipo de proyecto: <strong>{proyectoPP.tipo_proyecto}</strong> </ListGroup.Item>
                                                            <ListGroup.Item>Nombre del grupo: <strong>{proyectoPP.nombre_grupo}</strong> </ListGroup.Item>

                                                            <ListGroup.Item style={{ textAlign: 'right', marginTop: '10px' }}><Button onClick={() => navegarTo(proyectoPP.id_proyecto)}>Ver detalles del proyecto</Button> </ListGroup.Item>


                                                        </ListGroup>



                                                    </Card.Body>


                                                </Card>
                                            </Col>

                                        )
                                    })
                                    }

                                </Row>
                                <Row style={{ marginTop: '30px' }}>
                                    <Col>
                                        <h3>Listado de proyectos PP Joven 2023  ({proyectosPPJoven2023.length})</h3>
                                        {loadingPPJoven2023 &&
                                            <Spinner animation="border" role="status">
                                                <span className="visually-hidden">Cargando...</span>
                                            </Spinner>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    {proyectosPPJoven2023?.map(proyectoPP => {
                                        return (

                                            <Col sm={6} key={proyectoPP.id_proyecto} style={{ marginTop: '30px' }}>

                                                <Card>
                                                    {(proyectoPP.imagen_destacada !== "" && proyectoPP.imagen_destacada !== null) ?
                                                        <Card.Img variant="top" src={`https://trenquelauquen.gov.ar/public/pp2023/uploads/${proyectoPP.imagen_destacada}`}
                                                            style={{ width: '100%', maxHeight: '15rem', objectFit: 'cover' }} />
                                                        :
                                                        <Card.Img variant="top" src="https://trenquelauquen.gov.ar/public/pp2023/uploads/default-image.jpg"
                                                            style={{ width: '100%', maxHeight: '15rem', objectFit: 'cover' }} />

                                                    }
                                                    <Card.Body>
                                                        <Card.Title style={{ minHeight: '50px' }}> {proyectoPP.titulo_proyecto} <span> </span>
                                                            {proyectoPP.estado === "Borrador" && <Badge bg="warning" text="dark">Borrador</Badge>}
                                                            {proyectoPP.estado === "Presentado" && <Badge bg="success">Presentado</Badge>}
                                                        </Card.Title>

                                                        {proyectoPP.estado === "Borrador" &&
                                                            <Alert variant="warning">
                                                                Fecha de última actualización: {proyectoPP.fecha_borrador}
                                                            </Alert>
                                                        }
                                                        {proyectoPP.estado === "Presentado" &&
                                                            <Alert variant="success">
                                                                Fecha de presentación: {proyectoPP.fecha_entrega}
                                                            </Alert>
                                                        }
                                                        <ListGroup style={{ fontSize: '20px' }}>
                                                            <ListGroup.Item ><i className="bi bi-geo-alt"></i> {proyectoPP.localidad_proyecto}</ListGroup.Item>
                                                            <ListGroup.Item><i className="bi bi-currency-dollar"></i> {proyectoPP.monto_total_estimado}</ListGroup.Item>
                                                        </ListGroup>


                                                        <Accordion>
                                                            <Accordion.Item eventKey={proyectoPP.id_proyecto}>
                                                                <Accordion.Header><span style={{ fontSize: '20px' }}><i className="bi bi-person-fill-add"> </i> {proyectoPP.name_user}</span> </Accordion.Header>
                                                                <Accordion.Body>
                                                                    <p style={{ fontSize: '18px' }}><i className="bi bi-person-vcard"></i> {proyectoPP.dni}</p>
                                                                    <p style={{ fontSize: '18px' }}><i className="bi bi-envelope-at"></i> {proyectoPP.email_user}</p>
                                                                    <p style={{ fontSize: '18px' }}><i className="bi bi-phone"></i> {proyectoPP.telefono}</p>

                                                                </Accordion.Body>
                                                            </Accordion.Item>

                                                        </Accordion>


                                                        <ListGroup>
                                                            <ListGroup.Item>Tipo de proyecto: <strong>{proyectoPP.tipo_proyecto}</strong> </ListGroup.Item>
                                                            <ListGroup.Item>Nombre del grupo: <strong>{proyectoPP.nombre_grupo}</strong> </ListGroup.Item>

                                                            <ListGroup.Item onClick={() => navegarTo(proyectoPP.id_proyecto)} style={{ textAlign: 'right', marginTop: '10px' }}><Button>Ver detalles del proyecto</Button> </ListGroup.Item>


                                                        </ListGroup>



                                                    </Card.Body>


                                                </Card>
                                            </Col>

                                        )
                                    })}


                                </Row>
                                <Row style={{ marginTop: '30px' }}>
                                    <Col>
                                        <h3>Listado de Usuarios Registrados  ({usuariosProyectos.length})</h3>
                                        {loadingUsuarios &&
                                            <Spinner animation="border" role="status">
                                                <span className="visually-hidden">Cargando...</span>
                                            </Spinner>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    {usuariosProyectos?.map(usuario => {
                                        return (

                                            <Col xs="12" key={usuario.id_user} sm="4" style={{ marginTop: '20px' }}>

                                                {(usuario.id_user !== "1" && usuario.id_user !== "3") &&


                                                    <Card>
                                                        <Card.Body>
                                                            <Card.Title><i className="bi bi-person-fill-add"> </i> {usuario.name_user}</Card.Title>


                                                            <p style={{ fontSize: '18px' }}><i className="bi bi-person-vcard"></i> {usuario.dni}</p>
                                                            <p style={{ fontSize: '18px' }}><i className="bi bi-envelope-at"></i> {usuario.email_user}</p>
                                                            <p style={{ fontSize: '18px' }}><i className="bi bi-phone"></i> {usuario.telefono}</p>

                                                            {usuario.id_proyecto !== null &&
                                                                <>
                                                                    {usuario.titulo_proyecto}
                                                                    {usuario.estado === "Borrador" && <><Badge bg="warning" text="dark"><i className="bi bi-newspaper"></i> Borrador</Badge> {usuario.fecha_borrador}</>}
                                                                    {usuario.estado === "Presentado" && <><Badge bg="success"> <i className="bi bi-newspaper"></i>Presentado</Badge> {usuario.fecha_entrega}</>}
                                                                    <br /><Button onClick={() => navegarTo(usuario.id_proyecto)} style={{ marginTop: '10px' }}>Ver detalles del proyecto</Button>

                                                                </>
                                                            }
                                                            {usuario.id_proyecto === null &&
                                                                <><Badge bg="danger"> <i className="bi bi-newspaper"></i> Sin proyecto</Badge></>
                                                            }

                                                        </Card.Body>

                                                    </Card>

                                                }

                                            </Col>


                                        )
                                    }
                                    )}

                                </Row>
                            </>
                        }
                    </Container>
                    <div style={{marginBottom:'50px'}}>
                        <VotosEnBlanco />
                    </div>

                </>



            }


        </>
    )
}

export default PanelAdmin